import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Service will be insterted globally and consumers are able to subscribe to reset events
@Injectable({ providedIn: 'root' })
export class ResetService {
  // for advanced filters
  resetAdvancedFilters$ = new Subject<void>();

  resetAll(): void {
    this.resetAdvancedFilters$.next();
  }
}
